import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from '@phosphor-icons/react';

export default function LanguageSwitch() {
  const { language, cycleLanguage, languageNames } = useLanguage();

  const flagEmoji = {
    sq: '🇦🇱',
    en: '🇬🇧',
    it: '🇮🇹'
  };

  return (
    <button
      onClick={cycleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-xl glass-button transition-all duration-200 text-sm active:scale-95"
      data-testid="language-switch"
    >
      <span className="text-base">{flagEmoji[language]}</span>
      <span className="text-white/80 font-medium uppercase">{language}</span>
    </button>
  );
}
